<template>
    <div class="flex justify-between  items-center mx-24">
        <!----  Student details desktop-->
        <div class=" bg-white px-4 py-4 w-[540px] rounded-lg shadow-md">
            <h1 class="font-bold text-lg text-gray-900 text-center border-b border-b-gray-400 pb-2">Student
                details</h1>
            <table class="table border  mt-2 rounded-lg ">
                <tbody>
                    <tr class="bg-gray-200">
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            Gender
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ formattedGender }}
                        </th>
                    </tr>
                    <tr>
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            Class and Term
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ selectedClassroom }} {{ selectedTerm }}
                        </th>
                    </tr>
                    <tr class="bg-gray-200">
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            Admission Number
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ matricNumber }}
                        </th>
                    </tr>

                </tbody>
            </table>
        </div>

        <!----  Student Attendance desktop-->
        <div class=" bg-white px-4 py-4 w-[540px] rounded-lg shadow-md">
            <div class="flex justify-between items-center border-b border-b-gray-400 pb-2">
                <h1 class="font-bold text-lg text-gray-900 text-center ">Student Attendance</h1>
                <button @click="showAttendanceModal = true"
                    class="bg-primary text-white px-3 py-1 rounded text-sm hover:bg-primary transition">Set
                    Initial</button>
            </div>

            <table class="table border  mt-2 rounded-lg ">
                <tbody>
                    <tr class="bg-gray-200">
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            Session
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ studentSession.session }}
                        </th>
                    </tr>
                    <tr class="bg-gray-200">
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            No of times school opened
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ Number(settings.totalSchoolDay) }}
                        </th>
                    </tr>
                    <tr>
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            No of times present
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ totalPresent }}
                        </th>
                    </tr>
                    <tr class="bg-gray-200">
                        <th
                            class="border border-gray-900 px-2 py-2  whitespace-nowrap font-bold text-gray-900 text-left">
                            No of times absent
                        </th>
                        <th
                            class="border border-gray-900 px-2 py-2 whitespace-nowrap font-bold text-gray-900 text-left">
                            {{ totalAbsent }}
                        </th>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>

    <!-- Initial Attendance Modal -->
    <Dialog v-model:visible="showAttendanceModal" modal header="Set Initial Attendance" :style="{ width: '25rem' }">
        <div class="flex flex-col gap-4 mb-4">
            <div class="flex flex-col gap-2">
                <label for="present" class="font-semibold w-24">Days Present</label>
                <InputNumber id="present" v-model="initialAttendance.present" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2">
                <label for="absent" class="font-semibold w-24">Days Absent</label>
                <InputNumber id="absent" v-model="initialAttendance.absent" class="flex-auto" autocomplete="off" />
            </div>
            <div class="flex flex-col gap-2">
                <label for="late" class="font-semibold w-24">Days Late</label>
                <InputNumber id="late" v-model="initialAttendance.late" class="flex-auto" autocomplete="off" />
            </div>
        </div>
        <div class="flex justify-end gap-2">
            <Button type="button" label="Cancel" severity="secondary" @click="showAttendanceModal = false"></Button>
            <Button type="button" label="Save" @click="saveInitialAttendance" :loading="loading"></Button>
        </div>
    </Dialog>
</template>

<script setup lang="ts">
import { useUserStore } from '../../../store/userStore';
import { useQuery } from '@vue/apollo-composable';

import { useToast } from 'vue-toastification';
import gql from 'graphql-tag';
import { LocalStorageKeys } from '@/constants/LocalStorageKey.constant';
import { useUpdateAttendanceSummaryMutation } from '@/types/vue-apollo-helpers';

const userStore = useUserStore();
const toast = useToast();

const selectedTerm = localStorage.getItem(LocalStorageKeys.selectedTerm);
const selectedClassroom = localStorage.getItem(LocalStorageKeys.selectedClassroom);
const studentAttendance = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.studentAttendance)));
const studentSession = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.studentSession)));
const settings = ref(JSON.parse(localStorage.getItem(LocalStorageKeys.settings)));
const gender = userStore.gender;
const matricNumber = userStore.matricNumber;
const studentId = userStore.studentId; // Assuming studentId is available in userStore

const showAttendanceModal = ref(false);
const loading = ref(false);
const initialAttendance = ref({
  present: 0,
  absent: 0,
  late: 0,
});

// Fetch student details to get initial attendance
const { result, onResult } = useQuery(gql`
    query GetStudentInitialAttendance($id: ID!) {
        student(id: $id) {
            id
            initial_present_days
            initial_absent_days
            initial_late_days
        }
    }
`, { id: studentId });

onResult((queryResult) => {
  if (queryResult.data?.student) {
    initialAttendance.value.present = queryResult.data.student.initial_present_days || 0;
    initialAttendance.value.absent = queryResult.data.student.initial_absent_days || 0;
    initialAttendance.value.late = queryResult.data.student.initial_late_days || 0;
  }
});

const totalPresent = computed(() => Number(studentAttendance.value) + (initialAttendance.value.present || 0));

const totalAbsent = computed(() => {
  const calculatedAbsent = Number(settings.value?.totalSchoolDay) === 0 ? 0 : settings.value?.totalSchoolDay - Number(studentAttendance.value);
  return calculatedAbsent + (initialAttendance.value.absent || 0);
});

const { mutate: updateAttendanceSummary } = useUpdateAttendanceSummaryMutation();

const saveInitialAttendance = async() => {
  loading.value = true;
  try {
    const { data } = await updateAttendanceSummary({
      input: {
        student_id: studentId,
        initial_present_days: initialAttendance.value.present,
        initial_absent_days: initialAttendance.value.absent,
        initial_late_days: initialAttendance.value.late,
      },
    });

    if (data?.updateStudentAttendanceSummary?.success) {
      toast.success('Attendance summary updated successfully');
      showAttendanceModal.value = false;
    } else {
      toast.error(data?.updateStudentAttendanceSummary?.message || 'Failed to update attendance');
    }
  } catch (error) {
    toast.error('An error occurred');
  } finally {
    loading.value = false;
  }
};

const formattedGender = computed(() => {
  if (gender === 'F') {
    return 'Female';
  } else if (gender === 'M') {
    return 'Male';
  } else {
    return null;
  }
});

</script>

<style lang="scss" scoped></style>
